module.exports = __webpack_public_path__ + "img/lazar-logo.0766f28b.png";